import { CartItemTypeEnum } from '../cart/cart-item.ts';
import { CartItemSponsorshipSelected } from '../cart/sponsorship.ts';
import {
  ChildBase,
  ChildBirthday,
  ChildGender,
  ChildIcp,
  ChildImageUrl,
  ChildName,
} from '../children/childUtilityInterfaces.ts';

export enum UpsellItemTypeEnum {
  // Fund = 'Fund',
  Sponsorship = 'Sponsorship',
}

export type UpsellSponsorshipItem = {
  itemType: CartItemTypeEnum.Sponsorship;
  child: ChildBase &
    ChildBirthday &
    ChildGender &
    ChildImageUrl &
    ChildIcp &
    ChildName;
  sponsorship: CartItemSponsorshipSelected;
};

// export type UpsellFundItem = CartItemFund
//     & Pick<CartItemBase, 'id' | 'added' | 'amount'>;

export type UpsellItem = UpsellSponsorshipItem; // | UpsellFundItem;
